import React from "react";

export default function CreateAutom({ fill, className }) {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" fill="transparent" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.05608 2.01376C8.02098 1.99541 7.97913 1.99541 7.94402 2.01376L2.88292 4.65934C2.79636 4.7046 2.79636 4.82849 2.88292 4.87373L7.94402 7.5193C7.97913 7.53766 8.02098 7.53766 8.05608 7.5193L13.1172 4.87373C13.2037 4.82849 13.2037 4.7046 13.1172 4.65934L8.05608 2.01376ZM7.75796 8.04138C7.75796 7.99668 7.73334 7.95565 7.6939 7.93463L2.7749 5.31332C2.69432 5.27038 2.59705 5.32877 2.59705 5.42005V11.2576C2.59705 11.3023 2.62168 11.3433 2.66112 11.3643L7.58013 13.9856C7.66071 14.0286 7.75796 13.9702 7.75796 13.8789V8.04138ZM13.2251 5.31332C13.3056 5.27038 13.4029 5.32877 13.4029 5.42005V11.2576C13.4029 11.3023 13.3783 11.3433 13.3388 11.3643L8.41981 13.9856C8.33925 14.0286 8.24197 13.9702 8.24197 13.8789V8.04138C8.24197 7.99668 8.2666 7.95565 8.30606 7.93463L13.2251 5.31332Z" fill={fill ? fill : "#8F94A6"} />
        </svg>

    );
}




